import React from "react";
import Location from "../../../assets/images/location.png";
import Calender from "../../../assets/images/calender.png";
import Clock from "../../../assets/images/clock.png";
import SpeechSpeech from "../../../assets/images/speech-speech.png";
import Timmer from "../../../assets/images/timmer.png";
// import "../MainSection/MainSection.css";
import "./EventSection.css";


const EventSection = () => {
  return (
    <div>
      <div className="container">
        <div className="event-detailes-container">
          <h5 className="event-title">📍 Event Details:</h5>
          <div className="row justify-content-center eventContainer">
            <div className="col-lg-2 col-md-3 col-sm-6 col-12">
              <div className="event">
                <img src={Calender} alt="Calendar" />
            
                <p>April 23rd & 24th, 2025</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
              <div className="event">
                <img src={Location} alt="Location" />
                <p>Vijayawada</p>
              </div>
            </div>
              <div className="col-lg-3 col-md-3 col-sm-6 col-12">
              <div className="event">
                <img src={Clock} alt="Location" />
                <p>Timings- 9:30am to 5:30pm</p>
              </div>
            </div>
           
            <div className="col-lg-2 col-md-3 col-sm-6 col-12">
              <div className="event">
                <img src={Timmer} alt="Clock" />
                <p>Two Day Course</p>    
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-12">
              <div className="event">
                <img src={SpeechSpeech} alt="Speech" />
                <p>Arihant Raaj</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gainContainer">
        <div className="gainSubcontainer1">
          <div>🎓 What You’ll Learn:</div>
          <ul>
            <li>✅ The fundamentals of Vastu Shastra and how it impacts your personal and professional life</li>
            <li>✅ Introduction to Aromatherapy and its powerful effects on mind, mood, and environment</li>
            <li>✅ How to combine Aroma Oils with Vastu Remedies for holistic well-being</li>
            <li>✅ Practical techniques to balance energies at home and workplace</li>
            <li>✅ Personalized tips for your own space</li>
          </ul>
        </div>
        <div className="gainSubcontainer2">
          <div>💰 Course Fee:</div>
          <div>
            <div>
              💵 Regular Price: <strike> ₹22,000</strike>
            </div>
            <div>
              🔥 Special Offer: <span style={{ color: "#0BE93B" }}>₹11,000</span>{" "}
              {/* (Valid till March 16th only!) */}
            </div>
          </div> 
        <div>
          <h6>🎁 Bonus:</h6>
        <ul>
            
            <li>✅ Food</li>
            <li>✅ Participation Certificate</li>

           
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
};

export default EventSection;
